import { render, staticRenderFns } from "./PrintOrderA4.vue?vue&type=template&id=cebf81ea&scoped=true"
import script from "./PrintOrderA4.vue?vue&type=script&lang=js"
export * from "./PrintOrderA4.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderA4.vue?vue&type=style&index=0&id=cebf81ea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebf81ea",
  null
  
)

export default component.exports